import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  // tslint:disable-next-line: variable-name
  public static Create_WLE_Permission = 1;
  // tslint:disable-next-line: variable-name
  public static Read_WLE_Permission = 2;
  // tslint:disable-next-line: variable-name
  public static Update_WLE_Permission = 3;
  // tslint:disable-next-line: variable-name
  public static Admin_Manage_Documents_Permission = 4;
  // tslint:disable-next-line: variable-name
  public static Admin_Manage_Notification_Permission = 5;

  private roleList = [
    {code: 'admin', display: 'Administrator'},
    {code: 'data-entry-clerk', display: 'Data Management'},
    {code: 'decision-support', display: 'Decision Support'},
    {code: 'admin', display: 'Admin'}, // some existing practitioner role use 'Admin' as display name
  ];
  private permissionList = [
    {id: 1, permission: 'wle-create'},
    {id: 2, permission: 'wle-read'},
    {id: 3, permission: 'wle-update'},
    {id: 4, permission: 'admin-manage-documents'},
    {id: 5, permission: 'admin-manage-notification'}
  ];
  private roleToPermissions = [
    {role: 'admin', permissions: [1, 2, 3, 4, 5]},
    {role: 'data-entry-clerk', permissions: [1, 2, 3]},
    {role: 'decision-support', permissions: [2]}
  ];

  iHavePermission(permissionId: number): boolean {
    const role = sessionStorage.getItem(StorageService.keyUserRole);
    const foundRole = this.roleList.find(x => x.display.toLowerCase() === role?.toLowerCase());
    if (!foundRole) { return false; }
    const match = this.roleToPermissions.find(x => x.role === foundRole.code && x.permissions.includes(permissionId));
    if (!match) { return false; }
    return true;
  }
}
